const crypto = require("crypto");

class EncryptionHelper {
  constructor(securityKey) {
    this._encryptionKey = this.generateEncryptionKey(securityKey, 32);
    this._ivKey = this.generateEncryptionKey(securityKey, 16);
  }

  generateEncryptionKey(securityKey, size) {
    const hash = crypto.createHash("sha256").update(securityKey).digest();
    return Buffer.from(hash.slice(0, size));
  }

  encrypt(plainText) {
    try {
      const cipher = crypto.createCipheriv(
        "aes-256-cbc",
        this._encryptionKey,
        this._ivKey
      );
      let encrypted = cipher.update(plainText, "utf8", "base64");
      encrypted += cipher.final("base64");
      return encrypted;
    } catch (e) {
      console.error("A Cryptographic error occurred:", e.message);
      throw e;
    }
  }

  decrypt(cipherText) {
    try {
      const decipher = crypto.createDecipheriv(
        "aes-256-cbc",
        this._encryptionKey,
        this._ivKey
      );
      let decrypted = decipher.update(cipherText, "base64", "utf8");
      decrypted += decipher.final("utf8");
      return decrypted;
    } catch (e) {
      console.error("A Cryptographic error occurred:", e.message);
      throw e;
    }
  }
}

export default EncryptionHelper;

export const printView = function (divId = "") {
  if (divId == null) return;
  const modal = document.getElementById(divId);
  const cloned = modal.cloneNode(true);
  let section = document.getElementById("print");

  if (!section) {
    section = document.createElement("div");
    section.id = "print";
    section.classList.add("w-100");
    document.body.appendChild(section);
  }

  section.innerHTML = "";
  section.appendChild(cloned);

  for (let child of document.body.children) {
    if (child.id !== "print") {
      child.style.display = "none";
    }
  }

  window.print();

  for (let child of document.body.children) {
    if (child.id !== "print") {
      child.style.display = "";
    }
  }
};
String.prototype.insert = function (index, string) {
  if (index > 0) {
    return this.substring(0, index) + string + this.substr(index);
  }

  return string + this;
};

String.prototype.replaceAt = function (index, replacement) {
  return (
    this.substring(0, index) +
    replacement +
    this.substring(index + replacement.length)
  );
};

export const accountTypeConverter = function (item) {
  switch (item) {
    case 0:
      return "Vadesiz Mevduat";
    case 1:
      return "Vadeli Mevduat";
    case 2:
      return "Repo";
    case 3:
      return "Teminat Çekleri";
    case 4:
      return "Teminat Senetleri";
    case 5:
      return "Tahsil Çekleri";
    case 6:
      return "Tahsil Senetleri";
    case 7:
      return "Rotatif";
    case 8:
      return "Nakit Kredi Spot";
    case 9:
      return "Nakit Kredi İskonto";
    case 10:
      return "Teminat Mektubu";
    case 11:
      return "Harici Garanti";
    case 12:
      return "İhracat Akredidifi";
    case 13:
      return "Kabul Aval";
    case 14:
      return "Kredi Kartı Hesabı";
    case 15:
      return "Taksitli Kredi";
    case 16:
      return "Uzun/Orta Vadeli Kredi";
    case 17:
      return "Borç Çekleri";
    case 18:
      return "";
    case 19:
      return "Firma Kredi Kartı";
  }
};

export const numberConverter = function (number = 0.0, currency = null) {
  if (number == null || number === 0) return "0";

  let numberString = "" + number;
  let isMinus = false;

  if (numberString[0] === "-") {
    numberString = numberString.substring(1);
    isMinus = true;
  }

  let isFloat = numberString.indexOf(".");
  let beforeComma = "";

  if (isFloat !== -1) {
    beforeComma = numberString.substring(0, numberString.indexOf("."));
  } else {
    beforeComma = numberString;
  }

  let decimalCounter = 1;
  let loopCounter = beforeComma.length - 1;

  for (let i = loopCounter; i >= 0; i--) {
    if (i > 0 && decimalCounter % 3 === 0) {
      beforeComma = beforeComma.insert(i, ".");
    }
    ++decimalCounter;
  }

  if (isFloat !== -1) {
    numberString = numberString.substring(numberString.indexOf("."));
    let decimalPart = numberString.substring(0, 3);

    // Eğer decimalPart 1 basamaklı ise sonuna "0" ekle
    if (decimalPart.length === 2) {
      decimalPart += "0";
    }

    numberString = beforeComma + decimalPart.replace(".", ",");
  } else {
    // Tam sayı ise sonuna ",00" ekle
    numberString = beforeComma + ",00";
  }

  if (isMinus) numberString = "-" + numberString;

  return numberString + (currency ? " " + currency : "");
};
